module.exports = __webpack_public_path__ + "img/art_3_3.6fa6e4d3.jpg";